import styled from 'styled-components';

const ContainerStyled = styled.div`
  position: relative;
  width: 100%;
  height: 420px;
`;

export default ContainerStyled;
